import {http_get,http_post,http_post_file,form_post} from '../utils/request.js'
import my from '../utils/my.js'
function http(uri,method,vueObj,data,param,succFunc,errorFunc){
	  if(param==null||param==undefined){
	   	 param={};
	  }
	  var thenFuncSucc=response => {
	  	        my.log("recv -> "+JSON.stringify(response.data));
		  		    succFunc(response.data);
		      };
		var thenFunError=response => {
			     my.log("error -> "+JSON.stringify(response));
		      	  if(errorFunc){
		      	  	errorFunc(response)
		      	  }
		      };
	  
	 if('formpost'==method){
	 	form_post(uri, data).then(thenFuncSucc,thenFunError );
	 }else if('post'==method){
	 	http_post(uri, data).then(thenFuncSucc,thenFunError );
	 }else if('get'==method){
	 	http_get(uri, data).then(thenFuncSucc,thenFunError );
	 }else if('file'==method){
	 	http_post_file(uri, data).then(thenFuncSucc,thenFunError );
	 }else{
	 	http_get(uri, data).then(thenFuncSucc,thenFunError );
	 }
}
export default {
	formPost:(uri,vueObj,data,param,succFunc,errorFunc)=>http(uri,'formpost',vueObj, data,param,succFunc,errorFunc),//base对象
  post:(uri,vueObj,data,param,succFunc,errorFunc)=>http(uri,'post',vueObj, data,param,succFunc,errorFunc),//base对象
  get:(uri,vueObj,data,param,succFunc,errorFunc) =>http(uri,'get',vueObj, data,param,succFunc,errorFunc),
  postFile:(uri,vueObj,data,param,succFunc,errorFunc)=>http(uri,'file',vueObj, data,param,succFunc,errorFunc),
}